import { environment } from '../../../../environments/environment';

const SELECTED_STORE_INDEX_KEY = 'happy_selected_store_index';
const STORE_SCOPE_PREFIX = 'happy_store';

export function getHappyStoreScopeDomain(): string {
  const happyApi: any = (environment as any).happyApi || {};
  const stores = Array.isArray(happyApi.stores) ? happyApi.stores : [];

  if (stores.length > 0) {
    try {
      const rawIndex =
        window.sessionStorage.getItem(SELECTED_STORE_INDEX_KEY) ??
        window.localStorage.getItem(SELECTED_STORE_INDEX_KEY);
      const parsedIndex = Number(rawIndex);
      if (
        Number.isFinite(parsedIndex) &&
        parsedIndex >= 0 &&
        parsedIndex < stores.length
      ) {
        const selectedDomain = String(stores[parsedIndex]?.domain || '').trim();
        if (selectedDomain) {
          return selectedDomain;
        }
      }
    } catch {
      // Ignore storage failures and fall back to URL/first store.
    }

    const pathDomain = readPathStoreDomain(stores);
    if (pathDomain) {
      return pathDomain;
    }

    const firstDomain = String(stores[0]?.domain || '').trim();
    if (firstDomain) {
      return firstDomain;
    }
  }

  return 'default';
}

export function getStoreScopedKey(key: string): string {
  return `${STORE_SCOPE_PREFIX}:${getHappyStoreScopeDomain()}:${key}`;
}

function readPathStoreDomain(stores: { domain?: string }[]): string {
  if (typeof window === 'undefined') {
    return '';
  }
  try {
    const pathname = window.location?.pathname || '';
    const firstSegment = pathname.split('/').filter(Boolean)[0] || '';
    const hint = decodeURIComponent(firstSegment).trim().toLowerCase();
    if (!hint) {
      return '';
    }
    const match = stores.find(
      (store) => String(store?.domain || '').trim().toLowerCase() === hint
    );
    return match ? String(match.domain || '').trim() : '';
  } catch {
    return '';
  }
}
